export default {
  'channelDistributor.title': 'Distributors',
  'channelDistributor.description': 'Register and maintain distributors linked to company data.',

  'channelDistributor.columns.identity': 'Identity',
  'channelDistributor.columns.shortCode': 'Short code',
  'channelDistributor.columns.country': 'Country',
  'channelDistributor.columns.agreementId': 'Commercial agreement',
  'channelDistributor.columns.canCreatePartners': 'Can create partners',
  'channelDistributor.columns.canCreateResellers': 'Can create resellers',
  'channelDistributor.columns.partnerAgreementMode': 'Partner agreement mode',
  'channelDistributor.columns.defaultPartnerAgreementId': 'Default partner agreement',
  'channelDistributor.columns.defaultResellerAgreementId': 'Default reseller agreement',

  'distributorPartnerAgreementMode.automyManaged': 'Automy managed',
  'distributorPartnerAgreementMode.distributorManaged': 'Distributor managed',
};
